export default ({ get, checkStatus, toJSON }) => ({
  getPrintablesDetails: (id) =>
    get(`universe/v1/printables/${id}`).then(checkStatus).then(toJSON),
  getNewestPrintables: () =>
    get("universe/v1/newest_printables").then(checkStatus).then(toJSON),
});
